// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__-DvU4","text":"SelectPayment_text__3b-g3","title":"SelectPayment_title__21a_D","btn":"SelectPayment_btn__2Lpfr"};